exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-container[data-v-f25af26a]{position:sticky;z-index:100}.sticky-top[data-v-f25af26a]{top:-1px}", ""]);

// exports
